<template>

  <div class="data-table-page">
    <div style="font-size: 18px;text-align: left; margin-bottom: 12px; border-bottom: 2px solid gray; padding: 12px 0">
      数据介绍：中国碳排放权注册登记结算有限责任公司披露的全国碳市场交易结算信息,包括
      交易收盘价、最高价、最低价、总成交价与总成交额等信息。
    </div>

        <el-table
          :data="tableData"
          style="width: 100%">
          <el-table-column
            align="center"
            prop="date"
            label="交易日期">
          </el-table-column>
          <el-table-column
            align="center"
            prop="closingPrice"
            label="收盘价(元/吨)">
          </el-table-column>
          <el-table-column
            align="center"
            prop="maxPrice"
            label="最高价(元/吨)">
          </el-table-column>
          <el-table-column
            align="center"
            prop="minPrice"
            label="最低价(元/吨)">
          </el-table-column>
          <el-table-column
            align="center"
          prop="tradingVolume"
          label="总成交量(吨)">
        </el-table-column>
          <el-table-column
            align="center"
            prop="businessVolume"
            label="总成交额(元)">
          </el-table-column>
          <el-table-column
            align="center"
            width="310px"
            prop="digest"
            label="数据摘要">
          </el-table-column>
          <el-table-column
            align="center"
            width="200px"
            prop="blockTime"
            label="区块时间">
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="fetchList"
          :current-page.sync="currentPage"
          layout="prev, pager, next"
          :total="totalNum">
        </el-pagination>

        <div style="text-align: right;font-size: 15px;margin-top: 0">
          数据来源：{{source}}<br>
          合约地址：0x3616fa7200f5132430107fd78707d8b6d21a027e <br>
          分页接口：http://47.106.246.157:34568/cea/evidence/page?cur=1&size=10
        </div>
      </div>

</template>

<script>

export default {
  data() {
    return {
      currentPage: 1,
      tableData: [],
      totalNum: 10,
      source: "https://www.chinacrc.net.cn/list/101.html"
    }
  },
  components: {},
  computed: {},

  mounted() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      this.$http(null, '/data/cea/evidence/page', {
        cur: this.currentPage++,
        size: 10
      }, 'get').then(res => {
        this.tableData = res.records
        this.currentPage = res.current
        this.totalNum = res.total
      })
    }
  }
}
</script>

<style lang="scss" scoped>

.data-table-page::v-deep {
  padding: 20px;

  .el-table, .el-table__expanded-cell, .el-table tr, .el-table .el-table__expanded-cell, .el-table th.el-table__cell{
    background: transparent;
  }

  .el-table, .el-table thead {
    color: #fff;
  }



  .el-table__body {
    tr:hover>td{
      color: rgba(29, 35, 47, 1);
    }
  }

  .el-pagination {
    margin-top: 20px;
  }

  .el-pagination button:disabled, .el-pager li, .el-pagination .btn-next, .el-pagination .btn-prev{
    background: transparent;
    color: #fff;
  }

  .el-pager li.active {
    background: #fff;
    color: rgba(29, 35, 47, 1);
  }

}

.layout-container {
  height: 100vh;

  .el-aside {
    background-color: #232323;

    .el-menu {
      border-right: none;

    }
  }


}

</style>
